<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit"><h3  class="fNS-EB">CEO 인사말</h3></div>
      <div class="txt">
        <h6 class="lh40">
          “최고 경쟁력의 그룹 Infra Company, <br />
          페럼인프라 홈페이지를 방문해 주신 여러분을 진심으로 환영합니다.”
        </h6>
        <p class="pdt50 lh34">
          저희 페럼인프라는 2009년 그룹인프라 사업수행을 위해 설립되어 그룹사
          건물 관리를 시작으로 골프장 사업, MRO사업에 이르 기까지 다양한 사업을
          수행하고 있습니다. 설립초기에는 동국제강그룹의 페럼타워와 유니온빌딩
          건물관리를 수행하였으며 현재 페럼타워에서 페럼홀을 비롯한 대관 업무 및
          카페 아이리스의 운영을 맡고 있습니다.<br />
          또한 경기도 여주에 소재한 프리미엄 골프장인 페럼CC를 설립, 운영하고
          있으며, LPGA 챔피언쉽 ADT캡스, 교촌 허니레이디스 오픈 등 국내 메이저대회를
          지속적 개최하여 명품 골프장으로서의 입지를 굳혀 가고 있습니다.<br />
          2020년부터는 사업전환기를 맞이하여 인프라전문기업으로의 도약을 위해
          자원 인프라 사업인 MRO사업을 인수하여 운영 중이 며 현재 동국제강
          그룹사 뿐만 아니라 대외고객사들 대상으로 비약적인 사업 성장을 이루어
          나가고 있습니다.<br />
          페럼인프라는 동국제강그룹의 60년 기업가치와 문화를 바탕으로 미래를
          앞서가는 인프라 전문기업이 될 수 있도록 <br />
          최선을 다할 것을 약속 드립니다.
        </p>
        <h6 class="pdt50 tr">페럼인프라 대표이사 고문성</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "CeoTab.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/CeoTab.vue